let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6unZM")).then(() => parcelRequire('c0oNl'));